import { render, staticRenderFns } from "./HostesTab.vue?vue&type=template&id=2436c222&scoped=true"
import script from "./HostesTab.vue?vue&type=script&lang=js"
export * from "./HostesTab.vue?vue&type=script&lang=js"
import style0 from "./HostesTab.vue?vue&type=style&index=0&id=2436c222&prod&lang=scss&scoped=true"
import style1 from "./HostesTab.vue?vue&type=style&index=1&id=2436c222&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2436c222",
  null
  
)

export default component.exports